import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import ActiveIndicator from '../portal/controls/activeIndicator';

@inject('translationsStore') @observer
export default class LdapDefaultIndicatorContainer extends Component {
    
    t = this.props.translationsStore;

    render() {
        
        return (
            <ActiveIndicator
                active={this.props.active}
                activeText={this.t.translate('DEFAULT')}
                notActiveText={this.t.translate('NOT_DEFAULT')}
            />
        );
    }
}